import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-changePassword',
  templateUrl: 'changePassword.html',
})
export class ChangePasswordPage {

  constructor(public navCtrl: NavController) {
  }
}


// WEBPACK FOOTER //
// ./src/pages/account/changePassword/changePassword.ts